module.exports = __webpack_public_path__ + "img/product-placeholder-68.5986def.png";